import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditOffer from "./AddEditOffer";
import Window from "../2/Controls/Window";

class OfferList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      fullList: [],

      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      showAddOffer: false,
      showDelete: false,

      selectedRow: null,

      filter: {
        name: "",
        description: "",
        status: "active"
      },

      isFilterActive: false,

      listPageSettings: {

        Title: "Offers",

        Search: {

          showSearch: true,

          placeholder: "Search by offer name",

          onSearch: (text) =>
            this.onSearch(text),

          onRefresh: () =>
            this.onRefreshClick(),

          hideFilter: true

        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "popup"
          }

        ],

 Columns: [
          {
            Name: "Name",
            Type: "multiple",
            Columns: [{ Column: "Name" }, { Column: "Description" }],
          },
          {
            Name: "Details",
            Type: "multiple",
            Columns: [
              { Column: "ValidityFrom", Label: "Validity From", Type: "date" },
              { Column: "ValidityTo", Label: "Validity To", Type: "date" },
            ],
          },
          {
            Name: "Description",
            Type: "multiple",
            Columns: [
              { Column: "OfferType", Label: "Offer Type" },
              { Column: "PurchaseGroup", Label: "Purchase Group" },
              { Column: "PurchaseQty", Label: "Purchase Qty" },
              { Column: "FreeGroup", Label: "Free Group" },
              { Column: "FreeQty", Label: "Free Qty" },
            ],
          },
          {
            Name: "",
            Type: "multiple",
            ShowInMobile: true,
            Columns: [
              { Column: "Name", CSS: "main" },
              { Column: "OfferType", Label: "Offer Type" },
            ],
          },
        ],
        RowButtons: [

          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit",
            Action: "popup"
          },

          {
            ButtonType: "ImageButton",
            Type: "delete",
            Text: "Delete",
            Icon: "delete",
            Action: "delete"
          }

        ]

      }

    };

  }

  componentDidMount() {

    this.fetchData();

  }

  fetchData = async () => {

    this.setState({
      loading: true
    });

    try {

    const offers = await this.props.getOffers();

const data = offers.filter(
  (m) => m.hasOwnProperty("Type") && m.Type === "Offer"
);
      this.setState({

        fullList:
          Array.isArray(data)
            ? data
            : [],

        loading: false,
        page: 1

      },
        this.applyFilterAndPaging
      );

    }

    catch (error) {

      console.log(error);

      this.setState({
        loading: false
      });

    }

  };

  applyFilter = (data) => {

    const { name, description, status } =
      this.state.filter;

    let result = [];

    for (let i = 0; i < data.length; i++) {

      let item = data[i];

      let itemName = "";
      let itemDescription = "";
      let isDeleted = false;

      if (
        Object.prototype.hasOwnProperty.call(item, "Name")
      ) {
        itemName = String(item.Name);
      }

      if (
        Object.prototype.hasOwnProperty.call(item, "Description")
      ) {
        itemDescription = String(item.Description);
      }

      if (
        Object.prototype.hasOwnProperty.call(item, "IsDeleted")
      ) {
        isDeleted = item.IsDeleted;
      }

      let matchName =
        !name ||
        itemName
          .toLowerCase()
          .includes(name.toLowerCase());

      let matchDescription =
        !description ||
        itemDescription
          .toLowerCase()
          .includes(description.toLowerCase());

      let matchStatus = true;

      if (status === "active") {

        matchStatus = !isDeleted;

      }

      else if (status === "inactive") {

        matchStatus = isDeleted;

      }

      if (
        matchName &&
        matchDescription &&
        matchStatus
      ) {

        result.push(item);

      }

    }

    return result;

  };

  applyFilterAndPaging = () => {

    let filteredData =
      this.applyFilter(
        this.state.fullList
      );

    let from =
      (this.state.page - 1)
      * this.state.pageSize;

    let to =
      from + this.state.pageSize;

    this.setState({

      list:
        filteredData.slice(from, to),

      totalCount:
        filteredData.length,

      isFilterActive:

        this.state.filter.name !== "" ||

        this.state.filter.description !== "" ||

        this.state.filter.status !== "active"

    });

  };

  onSearch = (text) => {

    this.setState({

      filter: {

        ...this.state.filter,

        name: text

      },

      page: 1

    },

      this.applyFilterAndPaging

    );

  };

  onRefreshClick = () => {

    this.setState({

      filter: {

        name: "",
        description: "",
        status: "active"

      },

      page: 1,

      isFilterActive: false

    },

      this.fetchData

    );

  };

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddOffer: true,

        selectedRow: null

      });

    }

  };

  onRowButtonClicked = (btn, row) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddOffer: true,

        selectedRow: row

      });

    }

    if (btn.Action === "delete") {

      this.setState({

        showDelete: true,

        selectedRow: row

      });

    }

  };

  deleteRecord = async () => {

    const selectedRow =
      this.state.selectedRow;

    if (
      !selectedRow ||
      !Object.prototype.hasOwnProperty.call(selectedRow, "key")
    ) {

      alert("Invalid record");

      return;

    }

    try {

      await this.props.deleteOffer(
        selectedRow.key
      );

      this.setState({

        showDelete: false,

        selectedRow: null

      },

        this.fetchData

      );

    }

    catch (error) {

      console.log(error);

      alert(
        error.message ||
        "Delete failed"
      );

    }

  };

  onNextClick = () => {

    let totalPages =
      Math.ceil(

        this.state.totalCount
        / this.state.pageSize

      );

    if (
      this.state.page < totalPages
    ) {

      this.setState({

        page:
          this.state.page + 1

      },

        this.applyFilterAndPaging

      );

    }

  };

  onPreviousClick = () => {

    if (
      this.state.page > 1
    ) {

      this.setState({

        page:
          this.state.page - 1

      },

        this.applyFilterAndPaging

      );

    }

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({

      pageSize:
        Number(size),

      page: 1

    },

      this.applyFilterAndPaging

    );

  };

  onPostPopupSave = () => {

    this.setState({

      showAddOffer: false,

      selectedRow: null

    },

      this.fetchData

    );

  };

  onClosePopup = () => {

    this.setState({

      showAddOffer: false,

      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
  render() {

    return (

      <>

        <ListingPage
          {...this.props} 
            onPageChange={this.onPageChange}
          listPageSettings={{

            ...this.state.listPageSettings,

            Search: {

              ...this.state.listPageSettings.Search,

              isFilterActive:
                this.state.isFilterActive

            }

          }}

          list={
            this.state.list
          }

          loading={
            this.state.loading
          }

          totalItemsCount={
            this.state.totalCount
          }

          recordFrom={

            (
              this.state.page - 1
            )
            *
            this.state.pageSize

          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={
            this.onNextClick
          }

          onPreviousClick={
            this.onPreviousClick
          }

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />

        {this.state.showAddOffer && (

          <AddEditOffer

            {...this.props}

            selectedRecord={
              this.state.selectedRow
            }

            type="offers"

            onSave={
              this.onPostPopupSave
            }

            onClose={
              this.onClosePopup
            }

          />

        )}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal={true}

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(type) => {

              if (

                String(type)
                  .toLowerCase()

                === "yes"

              ) {

                this.deleteRecord();

              }

              else {

                this.setState({

                  showDelete: false,

                  selectedRow: null

                });

              }

            }}

            buttons={[

              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },

              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

      </>

    );

  }

}

export default OfferList;